import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

//constantes
const dataInicial = {
    data: {
        data: {},



    },
    maxNumPredio: 0,
    error: null




}
//types
const OBTENER_REGISTROS_PREDIOS_EXITO = 'OBTENER_REGISTROS_PREDIOS_EXITO'
const AGREGAR_REGISTRO_PREDIO_EXITO = 'AGREGAR_REGISTRO_PREDIO_EXITO'

const ACTUALIZAR_REGISTRO_PREDIO_EXITO = 'ACTUALIZAR_REGISTRO_PREDIO_EXITO'

const OBTENER_REGISTRO_PREDIO_BY_NUMERO_PREDIO_EXITO = 'OBTENER_REGISTRO_PREDIO_BY_NUMERO_PREDIO_EXITO'
const OBTENER_REGISTRO_PREDIO_BY_ID_ASOCIADO_EXITO = 'OBTENER_REGISTRO_PREDIO_BY_ID_ASOCIADO_EXITO'
const OBTENE_ULTIMO_REGISTRO_EXITO = 'OBTENE_ULTIMO_REGISTRO_EXITO'
const OBTENER_CREACION_DATO_PREDIO_EXITO = 'OBTENER_CREACION_DATO_PREDIO_EXITO'
const GENERAR_OFICIOS_EXITO = 'GENERAR_OFICIOS_EXITO'
const GENERAR_OFICIOS_EXITOG = 'GENERAR_OFICIOS_EXITOG'
export const obtenerRegistrosPredios = createAsyncThunk(
    OBTENER_REGISTROS_PREDIOS_EXITO,
    async () => {
        try {
            const fullUrl = host + `RegistroPredio/obtenerTodosRegistros`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)


export const obtenerRegistroPrediosByNumeroPredio = createAsyncThunk(
    OBTENER_REGISTRO_PREDIO_BY_NUMERO_PREDIO_EXITO,
    async (data) => {

        try {
            const fullUrl = host + `RegistroPredio/obtenerRegistroPrediosByNumeroPredio/${Number(data)}`

            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerRegistroPrediosByIdAsociado = createAsyncThunk(
    OBTENER_REGISTRO_PREDIO_BY_ID_ASOCIADO_EXITO,

    async (data) => {

        try {
            const fullUrl = host + `RegistroPredio/obtenerPrediosByIdAsociado/${data}`

            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)


export const agregarRegistroPredio = createAsyncThunk(
    AGREGAR_REGISTRO_PREDIO_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `RegistroPredio/agregarRegistroPredio`
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)


export const actualizarRegistroPredio = createAsyncThunk(
    ACTUALIZAR_REGISTRO_PREDIO_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `RegistroPredio/actualizarGuias`
            const result = await axios.put(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)


export const obtenerUltimoRegistro = createAsyncThunk(
    OBTENE_ULTIMO_REGISTRO_EXITO,
    async () => {
        try {
            const fullUrl = host + `RegistroPredio/obtenerUltimoRegistro`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)
export const creacionDatoPredio = createAsyncThunk(
    OBTENER_CREACION_DATO_PREDIO_EXITO,

    async (data) => {
        try {
            const fullUrl = host + `RegistroPredio/creacionDatoPredio`
            const fullUrlPredio = host + `DatosPredio/agregarDatosPredio`

            let datosPredio = {
                ...data.data.datospredio[0],
                idcliente: Number(data.data.datospredio[0].idcliente),
                longitudoeste: data.data.datospredio[0].longitudoeste,
                latitudnorte: data.data.datospredio[0].latitudnorte,
                superficiehectarea: data.data.datospredio[0].superficiehectarea,
                especie: data.data.datosmaguey[0].especie,
                tipoguia: data.data.tipoGuia
            }
            console.log("data ", data.data)
            const resAgregar = await axios.post(fullUrlPredio, { data: datosPredio })
            console.log("resAgregar ", resAgregar)

            data.data.datospredioGenerado = resAgregar?.data?.data

            if(data.data.kmlFile !== undefined || data.data.kmlFile !== null ){
                const iddatospredio = resAgregar.data.data.iddatospredio
    
                const kmlUrl = host + `PoligonoKml/agregarPoligonoKml`
                let formData = new FormData() 
                formData.append('archivo', data.data.kmlFile)
                formData.append('iddatospredio', iddatospredio)
                const resultado = await axios.post(kmlUrl,formData,{
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
            }

            const res = await axios.post(fullUrl,data)
            console.log("res ", res)
            return res;




        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const generarDocumentos = createAsyncThunk(
    GENERAR_OFICIOS_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'RegistroPredio/generarConstancia'
            const result = await axios.post(fullUrl, data)
            console.log('result: ', result)
            return {}
        } catch (error) {
            console.log(error);
        }
    }

)

export const generarDocumentosG = createAsyncThunk(
    GENERAR_OFICIOS_EXITOG,
    async (data) => {
        try {
            const fullUrl = host + 'RegistroPredio/generarGuias'
            const result = await axios.post(fullUrl, data)
            console.log('result: ', result)
            return {}
        } catch (error) {
            console.log(error);
        }
    }

)

export const registroPredioSlice = createSlice({
    name: 'registroPredioSlice',
    initialState: dataInicial,
    reducers: {

    },
    extraReducers: {

        [obtenerRegistrosPredios.fulfilled]: (state, { payload }) => {
            state.data = payload.data
        },

        [obtenerRegistroPrediosByIdAsociado.fulfilled]: (state, { payload }) => {

            state.data = payload.data
        },
        [agregarRegistroPredio.fulfilled]: (state, { payload }) => {

        },

        [actualizarRegistroPredio.fulfilled]: (state, { payload }) => {

        },

        [obtenerRegistroPrediosByNumeroPredio.fulfilled]: (state, { payload }) => {
            state.data = payload.data
        },

        [obtenerUltimoRegistro.fulfilled]: (state, { payload }) => {
            state.maxNumPredio = payload.data
        },

        [creacionDatoPredio.fulfilled]: (state, { payload }) => {

        },
        [creacionDatoPredio.rejected]: (state, { payload }) => {
            state.error = payload.error
        },
        [generarDocumentos.fulfilled]: (state, { payload }) => {

        },

        [generarDocumentosG.fulfilled]: (state, { payload }) => {

        },


    },
})


export const {
} = registroPredioSlice.actions
export const RegistroPredioReducerUsuarioAgricola = registroPredioSlice.reducer
